// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1ZVTW","info":"UpdateTermsInfo_info__2csvB"};